var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 15.8625C31 24.7062 24.8445 31 15.7541 31C7.03852 31 0 24.075 0 15.5C0 6.925 7.03852 0 15.7541 0C19.9975 0 23.5676 1.53125 26.3182 4.05625L22.0303 8.1125C16.4211 2.7875 5.99037 6.7875 5.99037 15.5C5.99037 20.9062 10.3799 25.2875 15.7541 25.2875C21.9922 25.2875 24.3299 20.8875 24.6984 18.6063H15.7541V13.275H30.7523C30.8984 14.0687 31 14.8312 31 15.8625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.766e5cf1e8d98f3790c4257ae038db4e.svg";
export { ForwardRef as ReactComponent };